import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { message } from 'antd';

// 默认API域名
// const DEFAULT_BASE_URL = 'http://127.0.0.1:8080';
const DEFAULT_BASE_URL = 'https://api-rt.scenetalk.top';

// 创建axios实例
const http = axios.create({
  timeout: 60000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    // 判断URL是否包含域名
    if (config.url && !config.url.startsWith('http')) {
      // 如果没有域名，则使用默认域名
      config.url = `${DEFAULT_BASE_URL}${config.url.startsWith('/') ? config.url : '/' + config.url}`;
    }
    
    // 添加管理端认证 Token 以通过后端防护
    const adminToken = localStorage.getItem('admin_token');
    if (adminToken) {
      config.headers['X-Admin-Token'] = adminToken;
    }
    
    console.log('请求URL:', config.url);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    const { data, headers } = response;
    // 如果是二进制数据（Blob），直接返回，不处理
    if (data instanceof Blob) {
      return response;
    }
    // 统一处理非 0 状态码
    if (data && data.code !== 0) {
      if (data.code === 401) {
        localStorage.removeItem('admin_token');
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      } else {
        // 自动弹出错误提示
        const errorMsg = data.errorMsg || data.message || '请求失败';
        message.error(errorMsg);
      }
    }
    return response;
  },
  (error) => {
    // 可以在这里对错误做统一处理
    if (error.response) {
      const { status, data } = error.response;
      if (status === 401 || (data && data.code === 401)) {
        localStorage.removeItem('admin_token');
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      } else {
        const errorMsg = data?.errorMsg || data?.message || '系统错误，请稍后再试';
        message.error(errorMsg);
      }
    } else {
      message.error('网络连接异常，请检查网络');
    }
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 封装GET请求
export const get = (url: string, params?: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse> => {
  return http({
    method: 'GET',
    url,
    params,
    ...config,
  });
};

// 封装POST请求
export const post = (url: string, data?: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse> => {
  return http({
    method: 'POST',
    url,
    data,
    ...config,
  });
};

// 封装PUT请求
export const put = (url: string, data?: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse> => {
  return http({
    method: 'PUT',
    url,
    data,
    ...config,
  });
};

// 封装DELETE请求
export const del = (url: string, config: AxiosRequestConfig = {}): Promise<AxiosResponse> => {
  return http({
    method: 'DELETE',
    url,
    ...config,
  });
};

// 封装文件下载请求
export const download = (url: string, data?: any, config: AxiosRequestConfig = {}): Promise<AxiosResponse<Blob>> => {
  return http({
    method: 'POST',
    url,
    data,
    responseType: 'blob',
    ...config,
  });
};

// 导出原始axios实例，以便在需要时使用
export default http;
